"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageBeanFieldConfigurationSchemeToJSON = exports.PageBeanFieldConfigurationSchemeFromJSONTyped = exports.PageBeanFieldConfigurationSchemeFromJSON = exports.instanceOfPageBeanFieldConfigurationScheme = void 0;
const FieldConfigurationScheme_1 = require("./FieldConfigurationScheme");
/**
 * Check if a given object implements the PageBeanFieldConfigurationScheme interface.
 */
function instanceOfPageBeanFieldConfigurationScheme(value) {
    return true;
}
exports.instanceOfPageBeanFieldConfigurationScheme = instanceOfPageBeanFieldConfigurationScheme;
function PageBeanFieldConfigurationSchemeFromJSON(json) {
    return PageBeanFieldConfigurationSchemeFromJSONTyped(json, false);
}
exports.PageBeanFieldConfigurationSchemeFromJSON = PageBeanFieldConfigurationSchemeFromJSON;
function PageBeanFieldConfigurationSchemeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'isLast': json['isLast'] == null ? undefined : json['isLast'],
        'maxResults': json['maxResults'] == null ? undefined : json['maxResults'],
        'nextPage': json['nextPage'] == null ? undefined : json['nextPage'],
        'self': json['self'] == null ? undefined : json['self'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'total': json['total'] == null ? undefined : json['total'],
        'values': json['values'] == null ? undefined : (json['values'].map(FieldConfigurationScheme_1.FieldConfigurationSchemeFromJSON)),
    };
}
exports.PageBeanFieldConfigurationSchemeFromJSONTyped = PageBeanFieldConfigurationSchemeFromJSONTyped;
function PageBeanFieldConfigurationSchemeToJSON(value) {
    if (value == null) {
        return value;
    }
    return {};
}
exports.PageBeanFieldConfigurationSchemeToJSON = PageBeanFieldConfigurationSchemeToJSON;
//# sourceMappingURL=PageBeanFieldConfigurationScheme.js.map